import React, { Component } from 'react';
import AuthApi from 'apis/Auth';
import { FormGroup, Label, Input } from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import 'assets/scss/login.css';

import {
  setRole,
  setToken,
  setBusinessId,
  setUserId,
  setDashboardMetricObject,
  setContactDetails,
  setBusinessPlan,
  setSessionTimeOut,
  setUserData,
} from 'constants/localStorageManager.js';
import {
  ROUTES,
  insertIdtoUrl,
  TRIAL_SIGNUP_ROUTES,
} from 'constants/Routes.js';
import { USERS } from 'constants/Users.js';
import { inputFocusHandler } from 'utils/userFormValidate';

import PasswordContainer from 'components/users/Password';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      pwd: '',
      loading: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onChange = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ loading: true });

    const { email, pwd } = this.state;
    let that = this;

    AuthApi.login(email, pwd)
      .then(response => {
        const token = response.headers.authorization;
        setToken(token);
        this.handleRedirect(response.data);
        setSessionTimeOut();
        that.setState({ loading: false });
      })
      .catch(function(error) {
        const { response, message } = error;
        that.setState({ loading: false });
        toast.error(() => {
          return (
            <div>
              <FontAwesomeIcon icon="exclamation-triangle" />
              {response.data.error || message}
            </div>
          );
        });
        console.log(error);
      });
  };

  handleRedirect = data => {
    const { dashboard } = data;
    if (!dashboard) {
      setContactDetails(data);
      this.props.history.push(TRIAL_SIGNUP_ROUTES.BUSINESS_DETAILS);
      return;
    } else {
      const { id, business, role, dashboard, plan } = data;
      setUserData(data);
      setUserId(id);
      setDashboardMetricObject(dashboard);
      setRole(role);
      setBusinessPlan(plan);

      if (role !== USERS.ADMIN) setBusinessId(business.id);
      const pushUrl =
        role === USERS.ADMIN
          ? ROUTES.DASHBOARD_INDEX
          : insertIdtoUrl(ROUTES.BUSINESS_DASHBOARD_INDEX, business.id);
      this.props.history.push(pushUrl);
    }
  };

  render() {
    const { loading } = this.state;
    const loggingIn = loading ? <FontAwesomeIcon icon="spinner" pulse /> : '';

    return (
      <PasswordContainer
        loading={loading}
        buttonContent="Login"
        handleSubmit={this.handleSubmit}
        forgotPassword
      >
        <FormGroup>
          <Label for="email">Email</Label>
          <Input
            id="email"
            name="email"
            type="email"
            placeholder="Email"
            onChange={e => this.onChange(e)}
            onBlur={inputFocusHandler}
            required
          />
          <div className="row error" id="emailError" />
        </FormGroup>
        <FormGroup>
          <Label for="pwd">Password</Label>
          <Input
            id="pwd"
            name="pwd"
            placeholder="Password"
            type="password"
            onChange={e => this.onChange(e)}
            onBlur={inputFocusHandler}
            required
          />
          <div className="row error" id="pwdError" />
        </FormGroup>
      </PasswordContainer>
    );
  }
}

Login.propTypes = {};
Login.defaultProps = {};

export default Login;



// WEBPACK FOOTER //
// ./src/containers/Login.js